const max_names = 15;

export const formDataLimits = {
  // Character limits for text fields
  project_description: 1000,
  industry: 500,

  // Array length limits
  candidate_names: max_names,
  domain_name_candidates: max_names,
  tlds: 10,
  // Numeric limits
  num_names: {
    min: 0,
    max: max_names,
  },
  num_domain_names: {
    min: 0,
    max: max_names,
  },
};

// Helper function to check if a value exceeds its limit
export const checkLimit = (fieldName, value, collectionLength) => {
  const limit = formDataLimits[fieldName];

  if (!limit) return { isValid: true, value };
  // Handle array limits
  if (Array.isArray(value)) {
    if (value.length > limit) {
      console.log(
        `${fieldName} exceeds limit of ${limit} items. Truncating to limit.`
      );
      return { isValid: false, value: value.slice(0, limit) };
    }
    return { isValid: true, value };
  }

  // Handle numeric limits
  if (typeof limit === "object" && "min" in limit && "max" in limit) {
    const numValue = Number(value);
    const maxAllowed = limit.max - collectionLength;

    if (numValue < limit.min) {
      console.log(
        `${fieldName} below minimum of ${limit.min}. Setting to minimum.`
      );
      return { isValid: false, value: limit.min };
    } else if (maxAllowed <= 0) {
      console.log(`No more names allowed. Maximum combined length reached.`);
      return { isValid: false, value: 0 };
    } else if (numValue > maxAllowed) {
      console.log(
        `Value exceeds maximum allowed combined length of ${maxAllowed}. Setting to maximum.`
      );
      return { isValid: false, value: maxAllowed };
    } else {
      return { isValid: true, value: numValue };
    }
  }

  // Handle string length limits
  if (typeof value === "string" && value.length > limit) {
    console.log(
      `${fieldName} exceeds ${limit} characters. Truncating to limit.`
    );
    return { isValid: false, value: value.substring(0, limit) };
  }

  return { isValid: true, value };
};
